import { DesignListCard } from '@cfs-fixings/shared'
import { DesignResource } from '@/api/serverApi'
import { Link } from 'react-router-dom'

type PropTypes = {
  designs?: DesignResource[]
  footerElements?: React.ReactNode[]
  dropdown?: (design: DesignResource) => React.ReactNode
}

function UngroupedDesignListView ({ designs, footerElements, dropdown }: PropTypes) {
  return (
    <ul className="w-full">
      {
        designs?.map((design) => (
          <li
            key={design.id}
            className="px-2.5 hover:bg-gray-50 [&>div]:last-of-type:border-b-0"
          >
            <div className="border-b-gray-100 border-b">
              <Link
                to={`/designs/${design.id}`}
              >
                <DesignListCard design={design} dropdown={dropdown?.(design)} />
              </Link>
            </div>

          </li>
        ))
      }
      {
        ...(footerElements ?? [])
      }
    </ul>
  )
}

export default UngroupedDesignListView
